import { create } from 'zustand';
import {
  applyThemeToDocument,
  getSystemScheme,
  loadStoredPreference,
  resolveScheme,
  type ColorScheme,
  THEME_STORAGE_KEY,
} from '@/theme/domTheme';

function persistPreference(preference: ColorScheme | null): void {
  try {
    if (preference == null) localStorage.removeItem(THEME_STORAGE_KEY);
    else localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    /* ignore */
  }
}

interface ThemeState {
  /** `null` = suivre les réglages système */
  preference: ColorScheme | null;
  systemScheme: ColorScheme;
  setPreference: (p: ColorScheme | null) => void;
  toggleResolved: () => void;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  preference: typeof window !== 'undefined' ? loadStoredPreference() : null,
  systemScheme: typeof window !== 'undefined' ? getSystemScheme() : 'light',

  setPreference: (p) => {
    persistPreference(p);
    set({ preference: p });
    applyThemeToDocument(resolveScheme(p));
  },

  toggleResolved: () => {
    const current = resolveScheme(get().preference);
    const next: ColorScheme = current === 'light' ? 'dark' : 'light';
    persistPreference(next);
    set({ preference: next });
    applyThemeToDocument(next);
  },
}));

if (typeof window !== 'undefined') {
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const onSystemChange = () => {
    const systemScheme: ColorScheme = mq.matches ? 'dark' : 'light';
    useThemeStore.setState({ systemScheme });
    applyThemeToDocument(resolveScheme(useThemeStore.getState().preference));
  };
  mq.addEventListener('change', onSystemChange);
}
